var map = {
	"./404.svg": "a14a",
	"./aiAnalysis.svg": "0fd6",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./data.svg": "5a0a",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./pull.svg": "bd07",
	"./qq.svg": "1430",
	"./search.svg": "8e8d",
	"./shift.svg": "75f8",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./statistics.svg": "a1cf",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";